import { RootState } from '@store/store'

export const getVoicesErrors = (state: RootState) => state.voices.error
export const getVoicesLoading = (state: RootState) => state.voices.loading
